import { memo } from "react";

function Dashboard() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="none" />
      <path
        d="M19.0206 10.1906C19.4163 11.7262 19.2977 13.3491 18.6829 14.8108C18.0682 16.2725 16.9911 17.4923 15.6168 18.2834C14.2425 19.0745 12.6467 19.3932 11.074 19.1906C9.50124 18.9881 8.03828 18.2755 6.90924 17.162C5.78019 16.0486 5.04734 14.5957 4.82295 13.0259C4.59857 11.4561 4.89503 9.85609 5.66691 8.47091C6.43879 7.08573 7.64353 5.99182 9.09654 5.35678C10.5495 4.72173 12.1707 4.58057 13.7116 4.95493"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19.7498 12C20.026 12 20.2514 11.7759 20.2347 11.5003C20.1793 10.5878 19.9726 9.68961 19.6219 8.84286C19.2073 7.84193 18.5996 6.93245 17.8335 6.16637C17.0674 5.40029 16.1579 4.7926 15.157 4.37799C14.3102 4.02726 13.4121 3.82052 12.4995 3.76515C12.2239 3.74842 11.9999 3.97386 11.9999 4.25L11.9999 11C11.9999 11.5523 12.4476 12 12.9999 12H19.7498Z"
        fill="#E4E6F1"
        stroke="#333333"
        strokeWidth="2"
      />
    </svg>
  );
}

export default memo(Dashboard);
